import { downgradeComponent } from "@angular/upgrade/static";

import { TeamMembersPageComponent } from "./team-members-page.component";

export const TeamMembersPageModuleAjsModule = angular
    .module('teamMembersPage', [])
    .directive('teamMembersPage', downgradeComponent({ component: TeamMembersPageComponent }))
    .config(
        ['$stateProvider', ($stateProvider) => {
            $stateProvider.state('missioncontrol.teamMembers', {
                url: '/teamMembers',
                component: TeamMembersPageComponent,
                data: {
                    requireLogin: true
                },
                params: {
                    managerObj: null,
                    iconClicked: null,
                    userType: null,
                    fromManagerCard: null
                }
            });
        }
        ])
    .name;